import initForm, { initExitPopupForm } from './components/form-handling'
import initButtonVisibility from './components/scroll-button'
import { initWebWorker } from './services/workerHandler'
import { initCountersObserver } from './components/counters-animation'
import initExitPopup from './components/exit-popup'
import initAnimation from './components/intersection-observer'
import { initCurrencyLandingsAnimations } from './components/currency-land-animations'
import { scrollToElement } from './components/scroll-to-element'
import cookieConsent from 'services/cookies-consent'
import { initHandleConditionalRedirects } from 'components/cookies-to-url'

initButtonVisibility()
initForm()
cookieConsent.init()
initExitPopupForm()
initWebWorker()
initCountersObserver()
initExitPopup()
initAnimation()
initCurrencyLandingsAnimations()
scrollToElement()
initHandleConditionalRedirects()
